export abstract class SuggestionsStructure {
  objectType: string;

  maxSuggest: number;

  protected constructor(attr: { objectType: string, maxSuggest: number }) {
    this.maxSuggest = attr.maxSuggest;
    this.objectType = attr.objectType;
  }
}
